var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.informationList.length)?_c('div',{staticClass:"wrap"},[_c('div',[_c('tw-table-system',{attrs:{"schemas":_vm.schemas,"height":269,"nopager":true,"items":_vm.informationList},on:{"row-click":_vm.rowClick}})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }